import static_datas from "./static_datas";

const datas = { ...static_datas };

export default datas;
